import React, { FC } from 'react';
import { PlayArrowIcon, TextDocumentIcon } from '@lifechurch/react-ion';

interface Props {
  hasImageCover: boolean;
  categoryLabel: React.ReactNode;
}

const CategoryLabel: FC<Props> = ({ hasImageCover, categoryLabel }) => {
  return (
    <>
      {hasImageCover ? (
        <div className='flex'>
          <TextDocumentIcon color={'white'} />
          {categoryLabel}
        </div>
      ) : (
        <div className='flex'>
          <PlayArrowIcon color={'white'} />
          {categoryLabel}
        </div>
      )}
    </>
  );
};

export default CategoryLabel;
